import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
import { AuthService } from './core/auth.service';
import { ConfigService } from './core/config.service';
import { LocalizedPaginatorIntl } from './core/paginator-intl';
import { applySavedTheme } from './layout/shell';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: MatPaginatorIntl, useClass: LocalizedPaginatorIntl },
    provideAppInitializer(async () => {
      applySavedTheme();
      inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined');
      const config = inject(ConfigService);
      const auth = inject(AuthService);
      await config.load();
      await auth.restore();
    }),
  ],
};
